<h2 mat-dialog-title>Schedule Transfer Form</h2>
<app-bulk-process [currentSchedule]="schedule"></app-bulk-process>